import { Player } from '@/API';
import FadeInWrapper from '@/components/Animated/FadeWrapper';
import Canvas from '@/components/Controls/Canvas';
import { Panel } from '@/components/Layouts/ContentPanel';
import * as queries from '@/graphql/queries';
import { useAmplifyApiClient } from '@/hooks/AmplifyApiClientHooks';
import { Stage } from 'konva/lib/Stage';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function CardView() {
  const client = useAmplifyApiClient();
  const { id } = useParams();

  const canvas = useRef<Stage>(null);
  const [player, setPlayer] = useState<Player | null>(null);
  const [drawing, setDrawing] = useState([]);

  useEffect(() => {
    const fetchDrawing = async () => {
      if (id) {
        const result = await client.graphql({ query: queries.getPlayerCard, variables: { id } });
        setDrawing(JSON.parse(result.data.getPlayerCard?.drawing ?? '[]'));

        const player = result.data.getPlayerCard?.playerId ?? '';
        const playerResult = await client.graphql({
          query: queries.getPlayer,
          variables: { id: player }
        });
        setPlayer(playerResult.data.getPlayer as Player);
      }
    };

    fetchDrawing();
  }, [id]);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.download = 'card.png';
    link.href = canvas.current?.toDataURL({
      mimeType: 'image/png',
      quality: 1
    }) as string;
    link.click();
  };

  return (
    <FadeInWrapper>
      <div className="mt-8">
        <Panel title="Card">
          <div className="flex flex-col items-center">
            <Canvas ref={canvas} drawing={drawing ?? []} isViewerMode={true} />
            <h4 className="text-xl font-semibold mt-4">{player?.name}</h4>
            <button className="btn btn mt-6" onClick={handleDownload}>
              Download
            </button>
          </div>
        </Panel>
      </div>
    </FadeInWrapper>
  );
}
